import * as THREE from 'three';
import { SVMLoader } from './SVMLoader.js';

const UP = new THREE.Vector3(0, 0, 1);

console.log("Allocating viewer constants");
let geometries = {};
let itemMeshes = {};
const loader = new SVMLoader();
const light = new THREE.AmbientLight( 0x404040, 5 );
const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
directionalLight.position.set(...UP);
const directionalLight2 = new THREE.DirectionalLight( 0xffffff, 0.3 );
directionalLight2.position.set(1, 1, 0);
//const directionalLight3 = new THREE.DirectionalLight( 0xffffff, 0.3 );
//directionalLight3.position.set(1, 0.5, 1);
const meshMaterial = new THREE.MeshStandardMaterial();
const scene = new THREE.Scene()
scene.add(light);
scene.add(directionalLight);
scene.add(directionalLight2);
//scene.add(directionalLight3);
const backgroundColor = new THREE.Color("#D3D3D3");
scene.background = backgroundColor;
const machineMaterial = new THREE.LineBasicMaterial( { color: 0x000000 , linewidth: 2 } );
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
let trays = [];
const trayOffset = 10;
let camera = null;
let needUpdate = true;
let partControl = null
let render = () => {};
let listener = () => {};
let activateSelectBottomFace = () =>  {};
let deactivateSelectBottomFace = () =>  {};
let currentMesh = null;

function itemIsFixed(item){
	return item.quantity === 1 && item.degrees_of_freedom > 2;
}

function updateItemState(item, mesh){
	mesh.scale.set(...item.scale);
	mesh.position.set(...item.position);
	mesh.quaternion.set(
		item.rotation[1],
		item.rotation[2],
		item.rotation[3],
		item.rotation[0],
	);
	mesh.quantity = item.quantity;
	mesh.degrees_of_freedom = item.degrees_of_freedom;
  mesh.tray_id = item.tray_id;
  mesh.itemSlug = item.slug;
}

let itemToDsg = {};

const PartMixin = (Base) => 
  class extends Base{
    constructor(slug, ...args){
      super(...args);
      this.slug = slug;
      this.controller = null;
      let _this = this;
      function hideController(){
        if(_this.controller){
          _this.controller.visible = false;
        }
      }
      function showController(){
        if(_this.controller){
          _this.controller.visible = true;
        }
      }
      this.addEventListener("added", (evt) => {
        _this.parent.parent.addEventListener("removed", hideController);
        _this.parent.parent.addEventListener("added", showController);
        _this.badParent = _this.parent.parent;
        console.log(_this.slug + " added to " + _this.badParent.trayId);
      });
      this.addEventListener("removed", (evt) => {
        if(_this.badParent){
          console.log(_this.slug + " removed from " + _this.badParent.trayId);
          _this.badParent.removeEventListener("removed", hideController);
          _this.badParent.removeEventListener("added", showController);
          _this.badParent = null;
        }
      });
    }

    setControl(controller, scene){
      this.controller = controller;
      this.controller.attach(this);
      scene.add(partControl.getHelper());
    }

    dispose(){
      if(this.controller){
        this.controller.visible = false;
      }
    }

    getTray(){
      if(this.parent){
        return this.parent.parent
      }
    }
  }

class PartMesh extends PartMixin(THREE.Mesh) {};
class PartLineSegments extends PartMixin(THREE.LineSegments) {};

class Tray extends THREE.Group{
  constructor(scene, trayId, ...args){
    super()
    console.log("new tray#", trayId);
    this.setTray(...args);
    this.trayId = trayId;
    scene.add(this);
    this.parts = new THREE.Group()
    this.add(this.parts);
    this.meshInstances = [];
    this.oldMeshInstances = [];
  }

  setTray(xTray, yTray, zTray, x0, y0, z0){
    this.machineBoxGeometry = new THREE.BoxGeometry(
      xTray, yTray, zTray
    );
		this.machineBoxGeometry.translate(x0 + xTray/2, y0 + yTray/2, z0 + zTray/2);
		this.machineGeometry = new THREE.EdgesGeometry(this.machineBoxGeometry);
		this.machineObject = new THREE.LineSegments( this.machineGeometry, machineMaterial );
    this.add(this.machineObject)
  }

  updateTray(...args){
    console.log("updating tray#", this.trayId);
    this._dispose();
    this.setTray(...args);
  }

  addInstances(...meshes){
    this.parts.add(...meshes);
  }

  removeInstances(...meshes){
    this.parts.remove(...meshes);
  }

  switchInstances(meshInstances){
    let oldMeshInstances = this.parts.children;
    this.parts.remove(...this.parts.children);
    if(meshInstances.length){
      this.parts.add(...meshInstances);
    }
    setTimeout(() => {
      oldMeshInstances.forEach((instance) => {
        // we can store both mesh and instanced mesh
        // they are not removed the same ways
        if(instance.hasOwnProperty("dispose")){
          instance.dispose()
        }
      });
    }, 0);
  }

  _dispose(){
    this.remove(this.machineObject);
    this.machineGeometry.dispose();
    this.machineBoxGeometry.dispose();
  }

  dispose(scene){
    console.log("removing tray#", this.trayId);
    if(scene){
      scene.remove(this)
    }
    this._dispose(scene);
    this.switchInstances([]);
  }
}

function meshChangeTray(mesh, trayId){
  if (trayId === -1){
    trayId = 0
  }
  const meshParent = mesh.getTray();
  if (meshParent instanceof Tray){
    // we are not changing tray nothing to do
    if(meshParent.trayId === trayId){
      return;
    }
    meshParent.removeInstances(mesh);
  }
  const tgtTray = trays[trayId];
  if(tgtTray instanceof Tray){
    tgtTray.addInstances(mesh);
    mesh.tray_id = trayId;
    console.log(mesh.slug + " moved to tray " + trayId) 
  }
}

function loadGeometries(items){
  let newGeometries = {};
  let newItemToDsg = {};
  let promises = [];
  for(const item of items){
    if(item.design && !item.display_model){
      continue;
    }
    let dsg;
    if(item.design){
      dsg = item.design;
    }else{
      dsg = item.slug;
    }
    newItemToDsg[item.slug] = dsg;
    if(geometries.hasOwnProperty(dsg) || newGeometries.hasOwnProperty(dsg)) continue;
    // placeholder
    newGeometries[dsg] = 1;
    if(item.type === "si" && item.size && (item.size[0] * item.size[1] * item.size[2] !== 0)){
      const promise = new Promise((resolve, reject) => {
        const boxGeometry = new THREE.BoxGeometry(
          item.size[0], item.size[1], item.size[2]
        );
        boxGeometry.translate(item.size[0]/2, item.size[1]/2, item.size[2]/2);
        const sinterBoxGeometry = new THREE.EdgesGeometry(boxGeometry);
        newGeometries[dsg] = {data: sinterBoxGeometry, count: 0, min: new THREE.Vector3(0, 0, 0)};
        resolve(dsg);
        console.log("Geometry processed for:", [item.slug, item.size]);
      });
      promises.push(promise);
    }else{
      const promise = new Promise((resolve, reject) => {
        loader.load(
          item.display_model,
          (stl) => {
            stl.computeBoundingBox();
            const v = stl.boundingBox.min.clone();
            console.log(v);
            stl.translate(-v.x, -v.y, -v.z);
            newGeometries[dsg] = {data: stl, count: 0, min: v};
            console.log("Geometry processed for:", [dsg, item.display_model, v]);
            resolve(dsg);
          },
          undefined,
          (error) => {
            console.log(error);
            newGeometries[dsg] = 0;
            resolve(dsg);
          }
        );
      });
      promises.push(promise);
    }
  }
  return Promise.all(promises).then(() => {
    geometries = {...geometries, ...newGeometries};
    itemToDsg = {...itemToDsg, ...newItemToDsg};
    console.log("Updated geometries:", geometries);
  });
}

export const viewerState = {
	setRender(_render){
		render = _render;
	},

  setActivateBottomFace(_activateBottomFace){
    activateSelectBottomFace = _activateBottomFace;
  },

  setDeactivateBottomFace(_deactivateBottomFace){
    deactivateSelectBottomFace = _deactivateBottomFace;
  },

  activateSelectBottomFace(){
    activateSelectBottomFace();
  },

  deactivateSelectBottomFace(){
    deactivateSelectBottomFace();
  },

	addGeometries (items) {
    const geometryLoaded = loadGeometries(items);
    return geometryLoaded.then(()=>{
      let newItemMeshes = {};
      for(const item of items){
        if(itemMeshes.hasOwnProperty(item.slug)){
          updateItemState(item, itemMeshes[item.slug]);
          continue;
        }
        const dsg = itemToDsg[item.slug];
          // item was not loaded, possibly because its import failed
        let geometry = geometries[dsg];
        if(!geometry){
          continue;
        }else if(geometry.data instanceof THREE.EdgesGeometry){
					newItemMeshes[item.slug] = new PartLineSegments( item.slug, geometry.data, machineMaterial );
        }else{
          newItemMeshes[item.slug] = new PartMesh(
            item.slug, geometry.data, meshMaterial
          );
          updateItemState(item, newItemMeshes[item.slug]);
        }
        geometry.count += 1;
      }
      itemMeshes = {...itemMeshes, ...newItemMeshes};
    });
	},

	removeGeometries(itemSlugs) {
		let newGeometries = {...geometries};
		let deleted = false;
		for(let itemSlug of itemSlugs){
      const mesh = itemMeshes[itemSlug];
      // the item was not loaded, possibly because of import failure
      if(!mesh) continue;
      const meshParent = mesh.getTray();
      if(meshParent instanceof Tray){
        meshParent.removeInstances(mesh);
      }
      const dsg = itemToDsg[itemSlug]
			let geometry = newGeometries[dsg];
      geometry.count -= 1;
			if(geometry.count === 0){
				delete newGeometries[dsg];
				geometry.data.dispose();
				deleted = true;
				console.log("Geometry disposed:", dsg);
			}
		}
		if(deleted){
			geometries = newGeometries;
			console.log("Updated geometries:", Object.keys(geometries));
		}
		render()
	},

	setControlMode(mode){
		partControl.setMode(mode);
	},

	showPartControl(){
		if(partControl){
			partControl.enabled = true;
			const helper = partControl.getHelper();
			if(helper) helper.visible = true;
			render();
		}
	},

	hidePartControl(){
		if(partControl){
			partControl.enabled = false;
			const helper = partControl.getHelper();
			if(helper) helper.visible = false;
			render();
		}
	},

	displayItem(itemSlug, trayId){
    if(trayId === -1){
      trayId = 0;
    }
    let meshInstances = {};
    trays.forEach((tray, i) => {
      meshInstances[i] = [];
    });
		const mesh = itemMeshes[itemSlug];
		if(itemIsFixed(mesh)){
			for(const itemMesh of Object.values(itemMeshes)){
				if(itemIsFixed(itemMesh) && meshInstances.hasOwnProperty(itemMesh.tray_id)){
          meshInstances[itemMesh.tray_id].push(itemMesh);
				}
			}
		}
		if(partControl){
      mesh.setControl(partControl, scene)
		}
    mesh.tray_id = trayId;
    if(meshInstances.hasOwnProperty(trayId)){
      meshInstances[trayId].push(mesh);
    }else{
    }
    trays.forEach((tray, i) => {
      tray.switchInstances(meshInstances[i]);
    });
		render()
	},

	setTransform(itemSlug, translation, rotation, scale, trayId){
		const mesh = itemMeshes[itemSlug];
    meshChangeTray(mesh, trayId);
		currentMesh = mesh;
		mesh.scale.set(...scale);
		mesh.rotation.set(
			rotation.x,
			rotation.y,
			rotation.z,
			rotation.order,
		);
		mesh.position.set(...translation);
		render()
	},

	transformCallback(){
		listener(currentMesh.position, currentMesh.rotation, currentMesh.scale);
	},

	setListener(callback){
		listener = callback;
	},

	clearListener(){
		listener = () => {};
	},

  setQuaternionForCurrentMesh(quaternion){
    currentMesh.applyQuaternion(quaternion);
    viewerState.transformCallback();
  },

	createOrUpdateMeshInstances(instances){
    let groupedInstances = {}
    trays.forEach((tray) => groupedInstances[tray.trayId] = {});
    instances.forEach(({matrix, component, tray_id}) => {
      const dsg = itemToDsg[component];
      if(dsg in geometries){
        if(tray_id in groupedInstances && dsg in groupedInstances[tray_id]){
          groupedInstances[tray_id][dsg].push(matrix);
        }else if(tray_id in groupedInstances){
          groupedInstances[tray_id][dsg] = [matrix];
        }
      }
    });
    for( const tray of trays){
      const trayGroupedInstances = groupedInstances[tray.trayId];
      let newMeshInstances = [];
      for( const [component, matrices] of Object.entries(trayGroupedInstances)){
        let needsUpdate = false;
        let instances = [];
        const geometry = geometries[component].data;
        if(geometry instanceof THREE.EdgesGeometry){
          for(let i = 0; i < matrices.length; i++){
            instances.push(new THREE.LineSegments(geometry, machineMaterial));
          }
        }else{
          needsUpdate = true;
          instances.push(new THREE.InstancedMesh(
            geometry, meshMaterial, matrices.length
          ));
        }
        const min = geometries[component].min.clone();
        newMeshInstances.push(...instances);
        matrices.forEach((matrix, i) => {
          const M = new THREE.Matrix4()
          M.set(
            matrix[0][0], matrix[0][1], matrix[0][2], matrix[0][3],
            matrix[1][0], matrix[1][1], matrix[1][2], matrix[1][3],
            matrix[2][0], matrix[2][1], matrix[2][2], matrix[2][3],
            matrix[3][0], matrix[3][1], matrix[3][2], matrix[3][3]
          );
          const G = new THREE.Matrix3();
          G.setFromMatrix4(M);
          const v = min.clone();
          v.applyMatrix3(G);
          M.elements[12] += v.x;
          M.elements[13] += v.y;
          M.elements[14] += v.z;
          let instance;
          if(needsUpdate){
            instance = instances[0];
            instance.setMatrixAt(i, M);
          }else{
            instance = instances[i];
            instance.applyMatrix4(M);
          }
        });
        if(needsUpdate){
          instances[0].instanceMatrix.needsUpdate = true;
        }
      }
      tray.switchInstances(newMeshInstances);
    }
		render();
	},

	updateMachineGeometry(xTray, yTray, zTray, x0, y0, z0, nTrays){
		console.log("New machine geometry", [xTray, yTray, zTray]);
    const dist = (yTray + y0 + trayOffset);
    let center = [(xTray + x0)/2, (nTrays*dist + y0)/2, (zTray + z0)/2];
    // I consider each tray a subscene
    trays.forEach((tray, i) => {
      tray.updateTray(xTray, yTray, zTray, x0, y0, z0);
      tray.position.set(-center[0], i*(yTray + y0 + trayOffset) - center[1], -center[2]);
    });
    let keptTray = trays.slice(0, nTrays);
    scene.add(...keptTray);
    let removedTray = trays.slice(nTrays);
    scene.remove(...removedTray);
    for(let i = trays.length; i < nTrays; i++){
      let tray = new Tray(scene, i, xTray, yTray, zTray, x0, y0, z0)
      tray.position.set(-center[0], i*dist - center[1], -center[2]);
      trays.push(tray);
    }
    return [[0, 0, 0], [xTray - x0, nTrays * yTray + (nTrays - 1)*(y0 + trayOffset), zTray - z0]]
	},

	setCamera(newCamera){
		newCamera.up = UP;
		if(camera){
			newCamera.position.set(...camera.position)
			newCamera.quaternion.set(...camera.quaternion)
		}
		camera = newCamera;
		if(camera){
			raycaster.setFromCamera(pointer, camera);
		}
		render()
	},

	setPartControl(controller){
		if(partControl){
      scene.remove(partControl);
		}
		partControl = controller;
	},

	updateScene(center, xSize, ySize, zSize, forceUpdate){
		if(camera && (needUpdate || forceUpdate)){
			camera.position.set(1.2*Math.max(xSize, ySize, zSize), ySize/2, zSize);
			camera.lookAt(...center);
			needUpdate = false;
		}
		render()
	},

	updateSceneAndMachineGeometry(xTrayMin, yTrayMin, zTrayMin, xTrayMax, yTrayMax, zTrayMax, nTrays){
		let [center, bb] = viewerState.updateMachineGeometry(
			xTrayMax - xTrayMin,
			yTrayMax - yTrayMin,
			zTrayMax - zTrayMin,
			xTrayMin,
			yTrayMin,
			zTrayMin,
      nTrays,
		);
		viewerState.updateScene(center, ...bb);
	},

	clearScene(){
    if(partControl){
      scene.remove(partControl);
    }
    trays.forEach((tray) => {
      tray.switchInstances([]);
    });
		render()
	},

	removeAllGeometries(){
    console.log("Cleaning viewer state");
    trays.forEach((tray) => {
      tray.switchInstances([]);
      tray.dispose();
    });
		itemMeshes = {};
		Object.values(geometries).forEach((geometry) => {
			geometry.data.dispose();
		});
		geometries = {}
	},

	getScene(){
		return scene;
	},
}
